import React from "react";
import {VoiceChat} from "@mui/icons-material";
import {MiniCard} from "./MiniCard";
import {useDashboard} from "../../../../context/DashboardContext";

export const TextToSpeechCard = () => {
  const {responseTime} = useDashboard();

  const avgSynthesize = (
    responseTime?.filter(i => +i?.avgSynthesize > 0)
      ?.map(i => +i?.avgSynthesize)
      ?.reduce((prev, next) => prev + next, 0) /
    responseTime?.filter(i => +i?.avgSynthesize > 0)?.length
  )?.toFixed(2) || 0;

  const chartData = responseTime?.map(i => ({
    ...i,
    dateCreated: i?.hour,
    duration: i?.avgSynthesize?.toFixed(2)
  }));

  return (
    <MiniCard
      icon={VoiceChat}
      color={"#dd9230"}
      title={`${avgSynthesize}s`}
      subtitle={"TEXT TO SPEECH"}
      data={chartData}
    />
  );
};
